const genTheme = (type: string) => (variable: string) =>
  `--medkit-${type}-${variable}`

export default genTheme
